import styled from 'styled-components';

export const FlowContainer = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  border-radius: 8px;
`;

export const EventBox = styled.div<{ $type: 'start' | 'success' | 'error' }>`
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  min-width: 140px;
  max-width: calc((600px - 48px) / 3); /* Account for margins and fit 3 boxes */
  flex: 1;
  margin: 5px;
  text-align: center;
  cursor: ${({ $type }) => ($type === 'error' ? 'pointer' : 'default')};
  overflow: hidden;
  border: 1px solid
    ${({ $type }) => {
      switch ($type) {
        case 'start':
          return '#94a3b8';
        case 'success':
          return '#a3d977';
        case 'error':
          return '#f87171';
        default:
          return '#94a3b8';
      }
    }};
  background: ${({ $type }) => {
    switch ($type) {
      case 'start':
        return '#f8fafc';
      case 'success':
        return '#f9fafb';
      case 'error':
        return '#fafafa';
      default:
        return '#f8fafc';
    }
  }};
  color: ${({ $type }) => {
    switch ($type) {
      case 'start':
        return '#1e40af';
      case 'success':
        return '#166534';
      case 'error':
        return '#dc2626';
      default:
        return '#1e40af';
    }
  }};

  &:hover {
    background: ${({ $type }) => {
      switch ($type) {
        case 'start':
          return '#f1f5f9';
        case 'success':
          return '#f7faf8';
        case 'error':
          return '#fef7f7';
        default:
          return '#f1f5f9';
      }
    }};
  }
`;

export const EventCount = styled.span<{ $type?: 'start' | 'success' | 'error' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  margin-left: 8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${({ $type }) => {
    switch ($type) {
      case 'start':
        return '#3b82f6';
      case 'success':
        return '#22c55e';
      case 'error':
        return '#ef4444';
      default:
        return '#3b82f6';
    }
  }};
  color: white;
`;

export const Title = styled.div`
  color: #6b7280;
  font-size: 14px;
  padding: 0 10px;
  font-weight: 500;
`;

export const EventTitle = styled.div`
  font-size: 10px;
`;

export const EventName = styled.div`
  font-size: 12px;
  color: #666;
  margin-top: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
`;

export const ErrorEventDisplay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 12px;
  color: #666;
  margin-top: 4px;
`;

export const ErrorEventCount = styled.span`
  font-weight: 600;
  color: #dc2626;
`;

export const HoverIcon = styled.span`
  font-size: 10px;
  color: #9ca3af;
  cursor: pointer;

  &::after {
    content: '🔍';
  }
`;
